export const ItemTypes = {
  File: 'file',
  Directory: 'dir',
};
